<template>
  <section class="row justify-content-center">
     <div class="col-md-8">
       <div class="p-2">
         <input type="search"  @keyup="btn_serach" name="serach" v-model="formData.search" class="form-control" placeholder="جستجو براساس کد پیگری">
       </div>
     </div>
    <div class="col-lg-12 " style="margin-top: 30px">
      <table class="table table-striped table-bordered ">
        <thead>
        <tr>
          <th>کد پیگری</th>
          <th>نام کاربر</th>
          <th>شماره تماس کاربر</th>
          <th>عنوان</th>
          <th>  قیمت اصلی / <span class="text-danger"> با تخفیف</span></th>
           <th>نوع پرداخت</th>
          <th>تعداد کد های تخفیف</th>
          <th>کد استفاده شد</th>
          <th>وضعیت پکیج</th>
          <th>وضعیت پرداخت</th>
          <th>تاریخ خرید</th>
          <th>مهلت پرداخت اعتباری</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="(list , index) in listCredit">
          <td> {{ list.tracking_code }}</td>
          <td>{{ list.user.name_f }}</td>
          <td>{{ list.user.phone_number }}</td>
          <td>{{ list.panel.title }}</td>
          <td>
             <span class="text-bold" title="قیمت اصلی">
               {{ number.numberFormats(list.panel.price ,  list.panel.buyCredit)}} |
             </span>
             <span class="text-danger" title="قیمت  با تخفیف"> {{
                 number.numberFormats(checkType(list?.panel?.price, list?.types, list?.panel?.buyCredit, list?.panel?.git_online))
               }}</span>
          </td>
           <td>{{ checkType2(list?.types) }}</td>
          <td>{{ list.panel.discount }}</td>
          <td>{{ list.counts }}

            <a href="#">
              <i class="fas fa-clipboard-list" data-bs-toggle="modal" data-bs-target="#staticBackdrop"></i>
            </a>
            <!-- Modal -->
            <div class="modal fade" id="staticBackdrop" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
              <div class="modal-dialog modal-lg">
                <div class="modal-content">
                  <div class="modal-header">
                    <h5 class="modal-title" id="staticBackdropLabel">لیست کاربرانی که دوره برای آن ها ثبت شده است</h5>
                  </div>
                  <div class="modal-body">
                    {{}}
                    <table class="table   table-striped table-bordered">
                      <thead>
                      <tr>
                        <th>#</th>
                         <th>شناسه کاربر</th>
                        <th>نام کاربر</th>
                        <th>شماره تماس</th>
                        <th>تاریخ</th>
                      </tr>
                      </thead>
                      <tbody>
                      <tr v-for="(row , index) in list.panel.purchases">
                        <td>{{index + 1}}</td>
                        <td>{{row.customer_id}}</td>
                        <td>{{row.customer_name}}</td>
                        <td>{{row.customer_mobile}}</td>
                        <td>{{datePersian.DatePersianTime(row.created_at)}}</td>
                      </tr>
                      </tbody>
                    </table>
                  </div>
                  <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">بستن</button>
                  </div>
                </div>
              </div>
            </div>

          </td>
          <td v-html="getStatus(list.status)"></td>
          <td v-html="statusPayment(list.payment_code)"></td>
          <td>{{ datePersian.DatePersianTime(list.created_at) }}</td>
          <td>{{ datePersian.converDatePersian(list.date_credits) }}</td>
        </tr>
        <tr>
          <td colspan="10">
            <nav class="text-danger">
              <ul class="pagination  " style="justify-content: center;">
                <li class="page-item">
                  <button class="btn btn-light " :disabled="!paginatetion.first_page_url" href="#"
                          v-on:click="myPaginate(paginatetion.first_page_url)" title="اولین"><i
                      class="fa fa-angle-double-right"></i></button>
                  <button class="btn btn-light " :disabled="!paginatetion.prev_page_url" href="#"
                          v-on:click="myPaginate(paginatetion.prev_page_url)" title="قبلی"><i
                      class="fa fa-angle-right"></i></button>
                </li>
                <li class="page-item">
                  <button class="btn btn-light" v-on:click="myPaginate(paginatetion.next_page_url)"
                          :disabled="!paginatetion.next_page_url" title="بعدی">
                    <i class="fa fa-angle-left"></i></button>

                  <button class="btn btn-light " :disabled="!paginatetion.last_page_url" href="#"
                          v-on:click="myPaginate(paginatetion.last_page_url)" title="اخرین"><i
                      class="fa fa-angle-double-left"></i></button>
                </li>
              </ul>
            </nav>
          </td>
        </tr>
        </tbody>
      </table>
    </div>
  </section>

</template>
<script setup>
import axios from "axios";
import {$ref} from "vue/macros";
import config from "../../../../config/config.json";
import * as datePersian from "@/common/helpers/DatePersian"
import {useToast} from "vue-toastification";
import * as number from "@/common/helpers/Number";
import {DatePersianTime} from "@/common/helpers/DatePersian";

const toast = useToast();
let url = `${config.BASE_URL}/panelCredits`;
let paginatetion = $ref({})
let listCredit = $ref({})
const formData = {
  search: ""
}

async function btn_serach() {
  try {
    const response = await axios.post('panelCredits/search', formData);
     listCredit = (response.data.status === "true") ? response.data.data : ""
  } catch (error) {
    if (error.response.status === 422) {
      const errorMessages = Object.values(error.response.data.errors).map(val => val[0]);
      errorMessages.forEach(errorMessage => {
        toast.error(errorMessage);
      });
    } else if (error.response.status === 404) {
      if (error.response.data.messages) {
        toast.error(error.response.data.messages);
      }
    }
  }
}
function checkType2(types) {
  if (types === 'credit') {
     return  "اعتباری"
  }
  if (types === 'payment') {
     return "آنلاین"

  }
  return price
}
function checkType(price, types, buyCredit, git_online) {
  console.log(types)
  if (types === 'credit') {
    return Credit(price, buyCredit)
  }
  if (types === 'payment') {
    return Credit(price, git_online)

  }
  return price
}

function Credit(price, discountPercentage) {
  if (discountPercentage) {
    if (price) {
      let percentageAmount = (price * discountPercentage) / 100;
      return parseInt(price) - parseInt(percentageAmount);

    }
  }
}


async function getCaredit() {
  try {
    const res = await axios.get(url);
    listCredit = (res.data.status) ? res.data.data.data : ""
    makePaginatetion(res.data.data);

  } catch (e) {
    console.log(e)
  }
}

async function copyContent(text) {
  try {
    await navigator.clipboard.writeText(text);
    toast.success("کپی شد");

  } catch (err) {
    console.error('Failed to copy: ', err);
  }
}


function makePaginatetion(data) {
  let paginatetions = {
    current_page: data.current_page,
    last_page_url: data.last_page_url,
    next_page_url: data.next_page_url,
    prev_page_url: data.prev_page_url,
    first_page_url: data.first_page_url
  }
  paginatetion = paginatetions;
}
function getStatus(status) {
  return (status === 'true') ? '<span class="text-success">فعال</span>' : '<span class="text-danger">منقضی شدن پرداخت</span>'
}
function statusPayment(status) {

  return (status) ? `<span class="btn text-success ">پرداخت شده</span>` : `<span class="btn text-danger">پرداخت نشده</span>`;
}
function myPaginate(urls) {
  url = urls;
  getCaredit()
}
getCaredit()
</script>
